














import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {get} from '../../services/webclient/webclient';
import $ from 'jquery';
import './_loader.less';

@Component({})

export default class loader extends Vue {

}
